import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { Theme, withStyles, makeStyles } from '@material-ui/core/styles';

const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
        backgroundColor: '#FFFFFF',
        color: '#282828',
        maxWidth: 296,
        fontSize: '18px',
        border: 'unset',
        borderRadius: '8px',
        padding: '13px 16px 13px 16px',
        fontFamily: 'Red Hat Display, sans-serif'
    },
    arrow: {
        color: '#FFFFFF',
        right: '66px',
    },
}))(Tooltip);

const useStyles = makeStyles({
    tooltipContent: {
        fontFamily: 'Gilroy-Medium, sans-serif',
        textAlign: 'center',
    },
    infoLog: {
        marginLeft: '10px',
        fontFamily: 'Times New Roman',
        fontStyle: 'italic',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#FFFFFF',
        fontSize: '16px',
        background: 'transparent',
        padding: '4px 8px',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid #99A1B6',
        cursor: 'pointer'
    }
});

export const InfoBox = ({title}: {title: string}) => {
    const classes = useStyles();
    return (
        <HtmlTooltip
            title={
                <React.Fragment>
                    <Typography className={classes.tooltipContent} color="inherit">
                        {title}
                    </Typography>
                </React.Fragment>
            }
            arrow
            placement="bottom-end"
        >
            <span className={classes.infoLog}>i</span>
        </HtmlTooltip>
    )
}